import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {playistEndpoint} from '../_constants/api.constant'
export async function createPlaylist(dataObj) {
    const response = await axios.post(
        playistEndpoint.POST,
        dataObj,
        {   
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}